import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AssessmentProvider } from "@/context/AssessmentContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Layout from "@/components/apexture/Layout";
import ScrollToTop from "@/components/apexture/ScrollToTop";
import Seo from "@/components/apexture/Seo";
import Landing from "@/pages/Landing";
import SafetyScreen from "@/pages/SafetyScreen";
import Assessment from "@/pages/Assessment";
import PosturePattern from "@/pages/PosturePattern";
import MuscularAssessment from "@/pages/MuscularAssessment";
import Report from "@/pages/Report";
import History from "@/pages/History";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Feedback from "@/pages/Feedback";
import AdminPanel from "@/pages/AdminPanel";
import { Terms, Privacy, Refund, Disclaimer } from "@/pages/Legal";
import "@/App.css";

export default function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Seo />
          <AuthProvider>
            <AssessmentProvider>
              <Layout>
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/safety-screen" element={<SafetyScreen />} />
                  <Route path="/assessment" element={<Assessment />} />
                  <Route path="/posture-pattern" element={<PosturePattern />} />
                  <Route path="/muscular-assessment" element={<MuscularAssessment />} />
                  <Route path="/report" element={<Report />} />
                  <Route path="/history" element={<History />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<Signup />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/payment-success" element={<PaymentSuccess />} />
                  <Route path="/feedback" element={<Feedback />} />
                  <Route path="/admin" element={<AdminPanel />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/refund" element={<Refund />} />
                  <Route path="/disclaimer" element={<Disclaimer />} />
                  <Route path="*" element={<Landing />} />
                </Routes>
              </Layout>
              <Toaster position="top-right" richColors />
            </AssessmentProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
      </ThemeProvider>
    </div>
  );
}
